/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TransferLineItemImageMetadata = {
  /**
   * Unique identifier for a image resource.
   */
  imageID: string;
  /**
   * Alternative text for the image.
   */
  altText?: string | undefined;
  /**
   * The image's public URL.
   */
  link: string;
  /**
   * A unique identifier for an image, used in public image links.
   */
  publicID: string;
};

/** @internal */
export const TransferLineItemImageMetadata$inboundSchema: z.ZodType<
  TransferLineItemImageMetadata,
  z.ZodTypeDef,
  unknown
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});
/** @internal */
export type TransferLineItemImageMetadata$Outbound = {
  imageID: string;
  altText?: string | undefined;
  link: string;
  publicID: string;
};

/** @internal */
export const TransferLineItemImageMetadata$outboundSchema: z.ZodType<
  TransferLineItemImageMetadata$Outbound,
  z.ZodTypeDef,
  TransferLineItemImageMetadata
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});

export function transferLineItemImageMetadataToJSON(
  transferLineItemImageMetadata: TransferLineItemImageMetadata,
): string {
  return JSON.stringify(
    TransferLineItemImageMetadata$outboundSchema.parse(
      transferLineItemImageMetadata,
    ),
  );
}
export function transferLineItemImageMetadataFromJSON(
  jsonString: string,
): SafeParseResult<TransferLineItemImageMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TransferLineItemImageMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TransferLineItemImageMetadata' from JSON`,
  );
}
